// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--1zp7p","content":"index-module--content--22PWH","headline":"index-module--headline--nYOo0","datenschutz":"index-module--datenschutz--feEZq"};